
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/video-size-reducer",
      function () {
        return require("private-next-pages/video-size-reducer/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/video-size-reducer"])
      });
    }
  